import { UseDatum } from 'react-usedatum';

export const [useKiosk, setKiosk, getKiosk] = UseDatum(false);
export const [useKioskGreen] = UseDatum(false);
